import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Group } from '../../user/model/user';

/**
 * Provides data access to the Group API.
 */
@Injectable({ providedIn: 'root' })
export class GroupService
{
  constructor(private http: HttpClient) { }

  /**
   * Get all groups.
   */
  public getGroups(admin: boolean = null): Observable<Group[]>
  {
    const adminQuery = admin ? '?admin=true' : '';
    return this.http.get<Group[]>(`/group/groups${adminQuery}`);
  }

  /**
   * Persist a Group in the database.
   *
   * @param data Data to save
   * @param isNew Is this a new Group?
   */
  public persistGroup(group: Group, isNew: boolean, groupId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/group', group);
    }
    else
    {
      return this.http.put(`/group/${groupId}`, group);
    }
  }

  /**
   * Get a Group by ID.
   *
   * @param id Group ID
   */
  public getGroup(id: number): Observable<Group>
  {
    return this.http.get<Group>('/group/' + id);
  }

  /**
   * Delete a group.
   *
   * @param groupId Group id
   */
  public deleteGroup(groupId: number): Observable<Group>
  {
    return this.http.delete<Group>(`/group/${groupId}`);
  }

  /**
   * Check if Group is in use
   *
   * @param data Group Id
   */
  public existsGroup(id: number): Observable<any>
  {
    return this.http.get(`/group/inuse/${id}`);
  }

}
